import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";
import { cubicBezier, easeInOut, motion, MotionValue, useTransform, type MotionStyle } from "motion/react";
import { useContext } from "react";
import { twMerge } from "tailwind-merge";

export default function PopOut({
  children,
  scrollProgress,
  fullDuration,
  fadeOut,
  className,
  style,
}: {
  children: React.ReactNode;
  scrollProgress?: MotionValue<number>;
  fullDuration?: boolean;
  fadeOut?: boolean;
  className?: string;
  style?: MotionStyle;
}) {
  // Animate
  const scrollYProgress = scrollProgress ? scrollProgress : useContext(ScrollAnimContext);
  const opacity = useTransform(scrollYProgress, fadeOut ? [0, 0.4, 0.6, 1] : [0, 0.4], fadeOut ? [0, 1, 1, 0] : [0, 1]);
  const scale = useTransform(scrollYProgress, fullDuration ? [0, 1] : [0, 0.4], [0.5, 1], { ease: cubicBezier(0, 0.55, 0.45, 1) });

  return (
    <motion.div style={{ scale, opacity, ...style }} className={twMerge(className)}>
      {children}
    </motion.div>
  );
}
